export const VERSION = 'github-pr-dashboard v0.1.0'
